module.exports = __webpack_public_path__ + "img/extensionAndAgent.8896733c.svg";